import React from 'react'

function Destination() {
  return (
    <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Destination
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Destination
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Destination Start */}
      <div className="container-xxl py-5 destination">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Destination
          </h6>
          <h1 className="mb-5">Popular Destination</h1>
        </div>
        <div className="row g-3">
          <div
            className="col-lg-5 col-md-6 wow zoomIn"
            data-wow-delay="0.1s"
            style={{ minHeight: 350 }}
          >
            <div
              className="position-relative d-block h-100 overflow-hidden"
              role="button"
              tabIndex={0}
              style={{ cursor: 'pointer' }}
            >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/himachal.jpg"
                alt="Himachal Pradesh"
                style={{ objectFit: "cover" }}
              />
              <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                20% OFF
              </div>
              <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                Himachal Pradesh
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-6">
            <div className="row g-3">
              <div
                className="col-lg-12 col-md-12 wow zoomIn"
                data-wow-delay="0.3s"
              >
                <div
                  className="position-relative d-block overflow-hidden"
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="img-fluid"
                    src="assets/img/goa.jpg"
                    alt="Goa"
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    30% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Goa
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.5s"
              >
                <div
                  className="position-relative d-block overflow-hidden"
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="img-fluid"
                    src="assets/img/kerela.jpg"
                    alt="Kerala"
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    25% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Kerala
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.7s"
              >
                <div
                  className="position-relative d-block overflow-hidden"
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="img-fluid"
                    src="assets/img/rajasthan.jpg"
                    alt="Rajasthan"
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    35% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Rajasthan
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-3 mt-4">
          <div className="col-lg-7 col-md-6">
            <div className="row g-3">
              <div
                className="col-lg-12 col-md-12 wow zoomIn"
                data-wow-delay="0.1s"
              >
                <div
                  className="position-relative d-block overflow-hidden"
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="img-fluid"
                    src="assets/img/agra.jpg"
                    alt="Agra"
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    28% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Agra
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.3s"
              >
                <div
                  className="position-relative d-block overflow-hidden"
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="img-fluid"
                    src="assets/img/varansi.jpg"
                    alt="Varanasi"
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    22% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Varanasi
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.5s"
              >
                <div
                  className="position-relative d-block overflow-hidden"
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="img-fluid"
                    src="assets/img/darjeeling.jpg"
                    alt="Darjeeling"
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    32% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Darjeeling
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-5 col-md-6 wow zoomIn"
            data-wow-delay="0.7s"
            style={{ minHeight: 350 }}
          >
            <div
              className="position-relative d-block h-100 overflow-hidden"
              role="button"
              tabIndex={0}
              style={{ cursor: 'pointer' }}
            >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/andaman.jpg"
                alt="Andaman & Nicobar"
                style={{ objectFit: "cover" }}
              />
              <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                26% OFF
              </div>
              <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                Andaman & Nicobar
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </div>
    {/* Destination Start */}
    </div>
  )
}

export default Destination
